// extracted by mini-css-extract-plugin
export default {"header":"HeaderMenu_header__sXdEm","link":"HeaderMenu_link__W9P4Y","subLink":"HeaderMenu_subLink__-cXT4","dropdownFooter":"HeaderMenu_dropdownFooter__RMn+y"};